import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _MessageCircleIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4974 4.00003C11.3351 3.99699 10.1884 4.26857 9.15088 4.79263L9.14709 4.79454L9.14709 4.79453C6.6065 6.06427 5.00113 8.6602 5.00003 11.5004L5.00002 11.5026C4.99699 12.665 5.26857 13.8116 5.79263 14.8492C5.91284 15.0872 5.93303 15.3633 5.84871 15.6163L4.58117 19.4189L8.3838 18.1513C8.63541 18.0675 8.91002 18.087 9.14724 18.2056C10.7487 19.0064 12.0577 19.0475 12.376 19.0078C12.4229 19.0019 12.4703 18.9994 12.5176 19.0002C13.3301 19.0144 14.6949 18.8253 16.0136 18.1992C17.3158 17.5809 18.5247 16.5627 19.1702 14.932C19.1814 14.9038 19.1938 14.8762 19.2074 14.8492C19.7315 13.8116 20.0031 12.665 20 11.5026L20 11.5V11.0284C19.7778 7.24294 16.7571 4.22222 12.9716 4.00003H12.5L12.4974 4.00003ZM12.5013 2.00003C11.0251 1.99639 9.56887 2.34122 8.25107 3.00647C5.03442 4.615 3.00182 7.90209 3.00003 11.4986C2.99671 12.8332 3.27825 14.1516 3.82392 15.3661L2.05134 20.6838C1.93157 21.0431 2.02509 21.4393 2.29292 21.7071C2.56075 21.975 2.95692 22.0685 3.31625 21.9487L8.63453 20.176C10.3336 20.9427 11.8187 21.0711 12.548 21.0007C13.6365 21.0092 15.2775 20.7627 16.8714 20.0059C18.5037 19.2308 20.1343 17.8947 21.0129 15.7105C21.6655 14.4029 22.0036 12.9607 22 11.4989V11C22 10.9817 21.9995 10.9633 21.9985 10.9449C21.7323 6.12019 17.8799 2.26772 13.0551 2.00155C13.0368 2.00053 13.0184 2.00003 13 2.00003H12.5013Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const MessageCircleIcon = assignWithoutSideEffects(_MessageCircleIcon, {
  componentId: 'MessageCircleIcon',
});

export default MessageCircleIcon;
